import axios from 'axios';

import routes from 'app/routes';

export default {
  load: (dispatch, successCallback = () => {}) => {
    axios
      .get(routes.api.users.show)
      .then((resp) => {
        dispatch({ type: 'LOAD', user: resp.data.data });

        const memberData = resp.data.data.attributes.specific;
        const imgs = document.querySelectorAll('.current-user-avatar');
        if (memberData.avatar_present) {
          const url = memberData.avatar_url;
          imgs.forEach((img) => {
            img.src = url;
          });
        } else {
          imgs.forEach((img) => {
            const url = img.dataset.defaulturl;
            if (url) {
              img.src = url;
            }
          });
        }
        successCallback();
      });
  },
  loadNotifications: (callback) => {
    axios
      .get(routes.api.users.notifications)
      .then((resp) => {
        callback(resp.data);
      });
  },
  readNotification: (notification) => {
    axios
      .post(routes.api.users.notificationRead, {
        object_type: notification.object_type,
        object_id: notification.object_id,
      })
      .then((_resp) => {

      });
  },
};
